export default __webpack_public_path__ + "static/media/Eye.0909e20d.svg";